module.exports = __webpack_public_path__ + "img/white.a267692e.png";